import { Icon } from '@yes.technology/react-toolkit'
import { useState } from 'react'
import { IconName } from './TableDocumentPreview.types'

export type ImagePreviewProps = {
  src: string
  alt?: string
  fallBackIcon?: IconName
}

function ImagePreview({
  src,
  alt = '',
  fallBackIcon = 'ImageFile'
}: ImagePreviewProps) {
  const [hasError, setHasError] = useState(false)

  if (hasError || !src) {
    return <Icon iconName={fallBackIcon} icSize='large' icColor='primary' />
  }

  return (
    <img
      src={src}
      alt={alt}
      style={{
        width: '100%',
        height: 'auto',
        objectFit: 'contain',
        borderRadius: '4px'
      }}
      onError={() => setHasError(true)}
    />
  )
}

export default ImagePreview
